export default "__VITE_ASSET__dc631ba1__"